import { InsertImageTool } from "./InsertImageTool";

export const SPTInsertImageTool = (uploadUrl, getResultUrl, richTextConfiguration, uid) => (props) => 
    <InsertImageTool 
        uploadUrl={uploadUrl}
        getResultUrl={getResultUrl}
        richTextConfiguration={richTextConfiguration}
        uid={uid}
        {...props} />